import React, { Suspense, lazy, useEffect, useState, useMemo, useCallback } from "react";
//import { Flag } from "../../components/Flag/Flag";
import config from "../../config";
import { sendXhrCall } from "../../utils/helpers";
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { Button, ButtonGroup, Chip, Skeleton, Stack } from '@mui/material';
import { Cancel } from '@mui/icons-material';
import { FixedSizeList as List } from "react-window";
//import { transform } from "lodash";
import _ from "lodash";
import { Layout } from '../Layout/Layout';
//import Trips from '../Trips/Trips';
//import Recommendations from "../Recommendations/Recommendations";
import "./MapComponent.scss";
import "../Trips/Trips.scss";
import "../Recommendations/Recommendations.scss";
import "../Layout/Layout.scss";
//import logoBlue from '../Layout/pangea-blue.png'; // Update this path to correctly point to your image file
import logoPlane from '../Layout/Pangea_logo_plane.svg';
import NewMapComponent from "./MapComponent";
const TripCard = lazy(() => import("../../components/Trip-card/Trip-card"));
const RecommendationsCard = lazy(() => import('../../components/Recommendations-card/Recommendations-card'));




interface PlaceLocation {
  lat: string;
  lng: string;
}

interface Recommendation {
  _id: string;
  place: {
    location: PlaceLocation;
    name: string;
    images: {
      urls: {
        thumb: string;
        raw: string;
      };
    };
    types: string[];
  };
  user: {
    firstName: string;
    lastName: string;
    avatar: string;
  };
  review: number;
  placeTypesTags: string[];
  locality: string;
  state_code: string;
}

/*interface RecommendationsProps {
  openModal: (arg: any) => void;
}*/


// TRIPS
interface TripPlaceLocation {
  description: string;
  location: {
    lat: string;
    lng: string;
  };
}

interface TripTraveler {
  _id: string;
  email: string;
  firstName: string;
  lastName: string;
  picture: string;
}

interface Trip {
  _id: string;
  title: string;
  whereTo: TripPlaceLocation[];
  statusType: string;
  travelers: TripTraveler[];
  images: {
    urls: {
      thumb: string;
      small: string;
      raw: string;
    };
  };
  daysRange: string;
  formattedDate: string;
}

/*interface TripData {
  data: Trip[];
  formattedDate: string;
}

interface TripsProps {
  openModal: (arg: any) => void;
}*/

const DesktopParentMapComponent = ({ mobile, modalIsOpen, closeModal, openModal, mapViewProps }: any) => {

  const [recs, setRecs] = useState<any[]>([])
  const [selectedRec, setSelectedRec] = useState<Recommendation | null>(null)
  const [loadingRecs, setLoadingRecs] = useState<true | false>(true)
  const [tags, setTags] = useState<any[]>([])
  const [locationTags, setLocationTags] = useState<any[]>([])
  const [lovedTags, setLovedTags] = useState<true | false>(false)
  const [savedPlaceTypes, setSavedPlaceTypes] = useState([])
  const [mapView, setMapView] = useState<'recs' | 'trips'>(mapViewProps);
  const { userId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  // TRIPS DATA STUFF !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
  const [tripsData, setTripsData] = useState<any[]>([])
  const [selectedTrip, setSelectedTrip] = useState<Trip | null>(null)
  const [loadingTrips, setLoadingTrips] = useState<true | false>(true)
  const [tripStatusFilter, setTripStatusFilter] = useState<null | 'Confirmed' | 'Tentative'>(null)

  const [updateCategory, setUpdateCategory] = useState<true | false>(false);
  const [isFilteringRecs, setIsFilteringRecs] = useState<boolean>(false);
  const [isFilteringTrips, setIsFilteringTrips] = useState<boolean>(false);



    // GET RECS !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    const fetchRecs = useCallback(async () => {
      if (!userId) return;
  
      setLoadingRecs(true);
      try {
        const query = new URLSearchParams(location.search);
        const queryLocations = query.get('places');
        const queryTags = query.get('tags');

        const [recsFromAPI, placeTypesGroupFromAPI] = await Promise.all([
            sendXhrCall(`${config.apigateway.recommendationsApi}${userId}`, 'get'),
            sendXhrCall(`${config.apigateway.placeTypesGroupApi}`, 'get'),
        ]);

        if (!_.isEqual(recs, recsFromAPI)) {
          setRecs(recsFromAPI ?? []);
        }
        
        if (!_.isEqual(locationTags, queryLocations ? [queryLocations] : [])) {
            setLocationTags(queryLocations ? [queryLocations] : []);
        }
        
        if (!_.isEqual(tags, queryTags ? [queryTags] : [])) {
            setTags(queryTags ? [queryTags] : []);
        }
        
        if (!_.isEqual(savedPlaceTypes, placeTypesGroupFromAPI.groups)) {
            setSavedPlaceTypes(placeTypesGroupFromAPI.groups ?? []);
        }
    

      } catch (error) {
          console.error("Error fetching recommendations:", error);
      } finally {
          setLoadingRecs(false);
      }
    }, [locationTags, recs, savedPlaceTypes, tags, userId, location.search]);
    
    const fetchTrips = useCallback(async () => {
      if (!userId) return;
  
      setLoadingTrips(true);
      try {
          const tripsFromAPI = await sendXhrCall(`${config.apigateway.tripsApi}${userId}?size=100`, 'get');
  
          if (!tripsFromAPI?.data?.length) {
              console.warn("No trips data received from API.");
              setTripsData([]);
              return;
          }
  
          const result = _.chain(tripsFromAPI.data)
              .uniqBy('_id')
              .groupBy("formattedDate")
              .map((items, formattedDate) => ({ formattedDate, data: items }))
              .value();
  
          if (!_.isEqual(tripsData, result)) {
              setTripsData(result);
          }
      } catch (error) {
          // Type guard for `Error`
          if (error instanceof Error) {
              console.error("Error fetching trips data:", error.message);
          } else {
              console.error("Unexpected error fetching trips data:", error);
          }
      } finally {
          setLoadingTrips(false);
      }
    }, [userId, tripsData]);
  
  
    
      

    useEffect(() => {
      if (mapViewProps === 'recs' && recs.length === 0) {
          fetchRecs();
      } else if (mapViewProps === 'trips' && tripsData.length === 0) {
          fetchTrips();
      }
  }, [mapViewProps, recs.length, tripsData.length, fetchRecs, fetchTrips]);
  


    useEffect(() => {
        if (updateCategory === true) {
            setTimeout(() => {
                setUpdateCategory(false);
            }, 2500)
        }
    }, [updateCategory]);


    // FIND FILTER TAGS FUNCTION
    const findFilterTags = useCallback((rec: Recommendation, tags: string[]): boolean => {
        if (!rec.placeTypesTags || !Array.isArray(rec.placeTypesTags)) {
            return false;
        }
        return tags.some(tag => rec.placeTypesTags.some(type => type === tag));
    }, []);
  
    const findLocationTags = useCallback((rec: Recommendation, locationTags: string[]): boolean => {
        if (!rec.locality && !rec.state_code) {
            return false;
        }
        let locationName = rec.locality || rec.state_code;
        return locationTags.some(tag => locationName === tag);
    }, []);
  
    const findLovedTags = useCallback((rec: Recommendation): boolean => {
        return rec.review === 2;
    }, []);


    // USEMEMO FOR FILTERING RECOMMENDATIONS BASED ON TAGS
    useEffect(() => {
      if (isFilteringRecs) {
          const timeout = setTimeout(() => setIsFilteringRecs(false), 300);
          return () => clearTimeout(timeout);
      }
  }, [isFilteringRecs]);
  
  useEffect(() => {
      if (isFilteringTrips) {
          const timeout = setTimeout(() => setIsFilteringTrips(false), 300);
          return () => clearTimeout(timeout);
      }
  }, [isFilteringTrips]);
  

  const filteredRecs = useMemo(() => {
  
      // Perform the filtering
      const result = recs.filter((rec) => {
          return (
              (tags.length > 0 ? findFilterTags(rec, tags) : true) &&
              (locationTags.length > 0 ? findLocationTags(rec, locationTags) : true) &&
              (lovedTags === true ? findLovedTags(rec) : true)
          );
      });
  
      return result;
  }, [recs, tags, locationTags, lovedTags, findFilterTags, findLocationTags, findLovedTags]);
  


    type LocationCount = { [key: string]: number };

    const allLocations = recs.map(rec => rec.locality || rec.state_code);

    // Creates an array of key/values that contains a count of each business type in the area
    const count = (allLocations: string[]): LocationCount =>
        allLocations.reduce((a: LocationCount, b: string) => ({
            ...a,
            [b]: (a[b] || 0) + 1,
        }), {});

    const sortable = Object.fromEntries(
        Object.entries(count(allLocations)).sort(([, a], [, b]) => b - a)
    );

    const mostCommonLocations = Object.entries(sortable);

    const topLocationsList = mostCommonLocations && mostCommonLocations.length ? mostCommonLocations : [];

    const urlLocations = locationTags && locationTags.length && locationTags.filter(location => {
        let mostCommonLocs = mostCommonLocations && mostCommonLocations.length && mostCommonLocations.map(commonLoc => commonLoc[0]);
        if (mostCommonLocs && mostCommonLocs.length && mostCommonLocs.some(commonLoc => commonLoc === location)) {
            return null;
        } else {
            return location;
        }
    });
    

    // Recs map filter tag buttons
    const lovedTagObject = {
        "value": true,
        "title": "Loved",
        "icon": "😍",
    };

    const recTagObjects = [
        {
            "_id": "65337c6f65d98ab149172893",
            "title": "Experience",
            "createdAt": "2023-10-21T07:23:27.651Z",
            "updatedAt": "2024-09-19T16:41:24.901Z",
            "__v": 0,
            "icon": "🥳",
            "rank": 8
        },
        {
            "_id": "65337c7165d98ab14917289c",
            "title": "Shop",
            "createdAt": "2023-10-21T07:23:29.831Z",
            "updatedAt": "2024-09-19T16:41:25.126Z",
            "__v": 0,
            "icon": "👜",
            "rank": 7
        },
        {
            "_id": "65337c7765d98ab1491728b6",
            "title": "Self Care",
            "createdAt": "2023-10-21T07:23:35.796Z",
            "updatedAt": "2024-09-19T16:41:25.358Z",
            "__v": 0,
            "icon": "💆",
            "rank": 11
        },
        {
            "_id": "65337c7965d98ab1491728bc",
            "title": "Restaurants",
            "createdAt": "2023-10-21T07:23:37.873Z",
            "updatedAt": "2024-04-18T20:01:13.919Z",
            "__v": 0,
            "icon": "🍽",
            "rank": 1
        },
        {
            "_id": "65337c7b65d98ab1491728c1",
            "title": "See",
            "createdAt": "2023-10-21T07:23:39.359Z",
            "updatedAt": "2024-09-19T16:41:25.685Z",
            "__v": 0,
            "icon": "👀",
            "rank": 4
        },
        {
            "_id": "65337c7e65d98ab1491728cf",
            "title": "Nature",
            "createdAt": "2023-10-21T07:23:42.668Z",
            "updatedAt": "2024-09-19T16:41:25.789Z",
            "__v": 0,
            "icon": "🏔",
            "rank": 10
        },
        {
            "_id": "65337c8165d98ab1491728d8",
            "title": "Services",
            "createdAt": "2023-10-21T07:23:45.295Z",
            "updatedAt": "2024-04-18T20:01:21.488Z",
            "__v": 0,
            "icon": "📋",
            "rank": 13
        },
        {
            "_id": "65337c8465d98ab1491728e0",
            "title": "Health",
            "createdAt": "2023-10-21T07:23:48.317Z",
            "updatedAt": "2024-09-19T16:41:26.239Z",
            "__v": 0,
            "icon": "🧘‍♀️",
            "rank": 9
        },
        {
            "_id": "65337c8865d98ab1491728ef",
            "title": "Café",
            "createdAt": "2023-10-21T07:23:52.879Z",
            "updatedAt": "2024-04-18T20:01:14.553Z",
            "__v": 0,
            "icon": "☕️",
            "rank": 3
        },
        {
            "_id": "65337c8a65d98ab1491728f1",
            "title": "Bar",
            "createdAt": "2023-10-21T07:23:54.069Z",
            "updatedAt": "2024-04-18T20:01:14.256Z",
            "__v": 0,
            "icon": "🥂",
            "rank": 2
        },
        {
            "_id": "65337c9065d98ab149172901",
            "title": "Stay",
            "createdAt": "2023-10-21T07:24:00.300Z",
            "updatedAt": "2024-09-19T16:41:27.131Z",
            "__v": 0,
            "icon": "🛌",
            "rank": 12
        },
        {
            "_id": "66217c09c4680774194f87ce",
            "title": "Coworking",
            "icon": "👩‍💻",
            "rank": 6,
            "createdAt": "2024-04-18T20:01:13.359Z",
            "updatedAt": "2024-04-18T20:01:13.359Z",
            "__v": 0
        },
        {
            "_id": "66217c09c4680774194f87cf",
            "title": "Coliving",
            "icon": "🤗",
            "rank": 5,
            "createdAt": "2024-04-18T20:01:13.615Z",
            "updatedAt": "2024-04-18T20:01:13.615Z",
            "__v": 0
        }
    ].sort((a, b) => a.rank - b.rank);


    
    const handleSelectedRecClick = (rec: Recommendation | null, selectedRec: Recommendation | null) => {
      
      let selectedRecId = selectedRec !== null ? selectedRec._id.toString() : null;
      let recId = ((rec && rec._id.toString()) || null);
      
      if ((selectedRecId === null) || (selectedRecId !== recId)) {
        setSelectedRec(rec);
      } else {
        openModal();
      }
    };



    /*const updateUrlWithFilters = () => {
        const params = new URLSearchParams();

        // Add the tags to the URL as query params
        if (tags.length > 0) {
            params.set('filters', tags.join(','));
        }

        // Update the URL
        const newUrl = `${window.location.pathname}/#/${userId}?${params.toString()}`;
        window.history.replaceState(null, '', newUrl);
    };*/


    const findTripStatus = (trip: Trip, tripStatusFilter: string) => {    
        if ((tripStatusFilter === 'All') || (trip.statusType && (trip.statusType === tripStatusFilter))) {
            return true;
        }
    };

  
  const filteredTripsListView = useMemo(() => {
      if (!Array.isArray(tripsData)) return [];
  
      return tripsData.map((tripsByMonth) => {
          if (!tripsByMonth.data || !tripsByMonth.data.length) {
              return [];
          }
  
          const filteredTrips = tripsByMonth.data.filter((trip: Trip) =>
              tripStatusFilter !== null ? trip.statusType === tripStatusFilter : true
          );
  
          return tripStatusFilter !== null
              ? { data: filteredTrips, formattedDate: tripsByMonth.formattedDate }
              : tripsByMonth;
      });
  }, [tripsData, tripStatusFilter]);
  
  const filteredTripsMapView = useMemo(() => {
      if (!Array.isArray(tripsData)) return [];
  
      const allTrips = tripsData.flatMap((tripsByMonth) =>
          tripsByMonth.data && tripsByMonth.data.length ? tripsByMonth.data : []
      );
  
      return allTrips.filter((trip) =>
          tripStatusFilter !== null ? findTripStatus(trip, tripStatusFilter) : true
      );
  }, [tripsData, tripStatusFilter]);


  const handleSelectedTripClick = (trip: Trip | null, selectedTrip: Trip | null) => {
    
    let selectedTripId = selectedTrip !== null ? selectedTrip._id.toString() : null;
    let tripId = ((trip && trip._id.toString()) || null);
    
    if ((selectedTripId === null) || ((selectedTripId !== null) && (selectedTripId !== tripId))) {
      setSelectedTrip(trip);
    } else {
      openModal();
    }
  };


  
  return (
      <div className="desktop-parent-map-component-parent-container">
        <div className="desktop-parent-map-component-side">
            <div className="desktop-parent-map-component-header">
                <div className="header-info">
                    <img
                        src={logoPlane}
                        alt="Logo"
                        style={{ height: '22px' }}
                    />
                    <div className="header-text">Explore the world, together</div>
                </div>
                <button className="open-app-btn" onClick={openModal}>Open App</button>
            </div>
            <div className="desktop-parent-map-component-profile">
                <Layout mobile={mobile} openModal={openModal} closeModal={closeModal} modalIsOpen={modalIsOpen}/>
            </div>
            <div className="desktop-parent-map-component-list">
                {(((mapView === 'recs') && (selectedRec === null)) || ((mapView === 'trips') && (selectedTrip === null))) ? (
                <div className="map-view-line-selected-desktop">
                    <ButtonGroup variant="text" aria-label="Basic button group" style={{ borderRadius: 25, backgroundColor: '#eeeeee' }}>
                        <Button 
                        onClick={() => {
                            if (mapView !== 'recs') {
                            setUpdateCategory(true);
                            setMapView('recs');
                            setLoadingRecs(false);
                            setLoadingTrips(true);
                            navigate(`/${userId}/recommendations`, { replace: true });
                            }
                        }} 
                        style={{ borderColor: 'transparent', width: 70, borderRadius: 25, fontFamily: 'Clashgrotesk, Arial, sans-serif', fontSize: '14px', fontWeight: 500, lineHeight: '20px', textTransform: 'none', color: (mapView === 'recs') ? 'white' : 'gray', backgroundColor: (mapView === 'recs') ? '#303646' : 'transparent' }}>
                            Recs
                        </Button>
                        <Button 
                        onClick={() => {
                            if (mapView !== 'trips') {
                            setUpdateCategory(true);
                            setMapView('trips');
                            setLoadingRecs(true);
                            setLoadingTrips(false);
                            navigate(`/${userId}/trips`, { replace: true });
                            }
                        }} 
                        style={{ borderColor: 'transparent', width: 70, borderRadius: 25, fontFamily: 'Clashgrotesk, Arial, sans-serif', fontSize: '14px', fontWeight: 500, lineHeight: '20px', textTransform: 'none', color: (mapView === 'trips') ? 'white' : 'gray', backgroundColor: (mapView === 'trips') ? '#303646' : 'transparent' }}>
                            Trips
                        </Button>
                    </ButtonGroup>
                </div>) : null}
                {(((mapView === 'recs') && (selectedRec === null)) || ((mapView === 'trips') && (selectedTrip === null))) ? (
                <div className="filter-line-desktop">
                    {(mapView === 'recs') ? (
                        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <Stack direction="row" spacing={1} sx={{ width: '90%', overflowX: 'scroll', scrollbarWidth: 'none', '&::-webkit-scrollbar': { display: 'none' } }}>
                            <Chip 
                                key={lovedTagObject.title}
                                onClick={() => {
                                    const checked = lovedTags === true;
                                    let filterTag = checked ? false : true
                                    setLovedTags(filterTag)
                                    setIsFilteringRecs(true);
                                }}
                                label={
                                <span>
                                    {lovedTagObject.icon} <span style={{ marginLeft: '2px' }}>{lovedTagObject.title}</span>
                                </span>
                                } clickable style={{ whiteSpace: 'pre', height: '24px', padding: '10px 10px', borderRadius: '8px', fontFamily: 'Clashgrotesk, Arial, sans-serif', fontSize: '12px', fontWeight: 500, lineHeight: '20px', textTransform: 'none', color: (lovedTags === true) ? 'white' : '#303646', backgroundColor: (lovedTags === true) ? '#303646' : '#F3F4F7', border: '1px solid var(--white-100, #FFF)' }} 
                            />
                            {recTagObjects && recTagObjects.map((tagObject, index) => (
                                <Chip 
                                key={`${tagObject._id}-${index}`}
                                className="filter-chip"
                                onClick={() => {
                                    const value = tagObject._id;
                                    const checked = tags.includes(tagObject._id);
                                    let filterTag = checked ? tags.filter((tags) => tags !== value) : [...tags, value]
                                    setTags(filterTag);
                                    setIsFilteringRecs(true);
                                }}
                                label={
                                    <span>
                                    {tagObject.icon} <span style={{ marginLeft: '4px' }}>{tagObject.title}</span>
                                    </span>
                                } clickable style={{ height: '24px', padding: '10px 10px', borderRadius: '8px', fontFamily: 'Clashgrotesk, Arial, sans-serif', fontSize: '12px', fontWeight: 500, lineHeight: '20px', textTransform: 'none', color: (tags.includes(tagObject._id)) ? 'white' : '#303646', backgroundColor: (tags.includes(tagObject._id)) ? '#303646' : '#F3F4F7', border: '1px solid var(--white-100, #FFF)' }} />
                            ))}
                            </Stack>
                            <Stack direction="row" spacing={1} sx={{ mt: 2, width: '90%', overflowX: 'scroll', scrollbarWidth: 'none', '&::-webkit-scrollbar': { display: 'none' } }}>
                            <Chip 
                                onClick={() => {
                                    navigate(`/${userId}/recommendations`, { replace: true });
                                    setLocationTags([]);
                                    setTags([]);
                                    setLovedTags(false);
                                    setIsFilteringRecs(true);
                                }}
                                label='All' clickable style={{ height: '24px', padding: '10px 10px', borderRadius: '8px', fontFamily: 'Clashgrotesk, Arial, sans-serif', fontSize: '12px', fontWeight: 500, lineHeight: '20px', textTransform: 'none', color: ((!locationTags.length) && (!tags.length)) ? 'white' : '#303646', backgroundColor: ((!locationTags.length) && (!tags.length)) ? '#303646' : '#F3F4F7', border: '1px solid var(--white-100, #FFF)' }}
                            />
                            {loadingRecs ? (
                                <Chip 
                                label={'...'} 
                                style={{ height: '24px', padding: '10px 10px', borderRadius: '8px', fontFamily: 'Clashgrotesk, Arial, sans-serif', fontSize: '12px', fontWeight: 500, lineHeight: '20px', textTransform: 'none', color: '#303646', backgroundColor: '#F3F4F7', border: '1px solid var(--white-100, #FFF)' }}
                                />
                            ) : null}
                            {urlLocations && urlLocations.length ? urlLocations.map((urlLoc, index) => (
                                <Chip 
                                key={`${urlLoc}-${index}`}
                                onClick={() => {
                                    const value = urlLoc;
                                    const checked = locationTags.includes(urlLoc);
                                    let filterTag = checked ? locationTags.filter((tags) => tags !== value) : [...locationTags, value]
                                    setLocationTags(filterTag)
                                    setIsFilteringRecs(true);
                                }}
                                label={loadingRecs ? '...' : `${urlLoc}`} clickable style={{ height: '24px', padding: '10px 10px', borderRadius: '8px', fontFamily: 'Clashgrotesk, Arial, sans-serif', fontSize: '12px', fontWeight: 500, lineHeight: '20px', textTransform: 'none', color: (locationTags.includes(urlLoc)) ? 'white' : '#303646', backgroundColor: (locationTags.includes(urlLoc)) ? '#303646' : '#F3F4F7', border: '1px solid var(--white-100, #FFF)' }} />
                            )) : null}
                            {topLocationsList && topLocationsList.length ? topLocationsList.map((loc, index) => (
                                <Chip 
                                key={`${loc}-${index}`}
                                onClick={() => {
                                    const value = loc && loc.length && loc[0];
                                    const checked = locationTags.includes(loc && loc.length && loc[0]);
                                    let filterTag = checked ? locationTags.filter((tags) => tags !== value) : [...locationTags, value]
                                    setLocationTags(filterTag)
                                    setIsFilteringRecs(true);
                                }}
                                label={loadingRecs ? '...' : `${loc && loc.length && loc[0]} (${loc && loc.length && loc[1]})`} clickable style={{ height: '24px', padding: '10px 10px', borderRadius: '8px', fontFamily: 'Clashgrotesk, Arial, sans-serif', fontSize: '12px', fontWeight: 500, lineHeight: '20px', textTransform: 'none', color: (locationTags.includes(loc && loc.length && loc[0])) ? 'white' : '#303646', backgroundColor: (locationTags.includes(loc && loc.length && loc[0])) ? '#303646' : '#F3F4F7', border: '1px solid var(--white-100, #FFF)' }}
                                />
                            )) : (
                                <Chip 
                                label={loadingRecs ? '...' : 'N/A'} 
                                disabled={true}
                                style={{ height: '24px', padding: '10px 10px', borderRadius: '8px', fontFamily: 'Clashgrotesk, Arial, sans-serif', fontSize: '12px', fontWeight: 500, lineHeight: '20px', textTransform: 'none', color: '#303646', backgroundColor: '#F3F4F7', border: '1px solid var(--white-100, #FFF)' }} 
                                />
                            )}
                            
                            </Stack>
                        </div>
                        ) : (
                        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <Stack direction="row" spacing={1} style={{ marginTop: 10 }}>
                            <Chip 
                                onClick={() => {
                                navigate(`/${userId}/trips`, { replace: true });
                                if (tripStatusFilter !== null) {
                                    setTripStatusFilter(null); // Only update if necessary
                                }
                                if (!isFilteringTrips) {
                                    setIsFilteringTrips(true); // Only update if not already filtering
                                }
                                }}
                                label='All' clickable style={{ height: '24px', padding: '10px 10px', borderRadius: '8px', fontFamily: 'Clashgrotesk, Arial, sans-serif', fontSize: '12px', fontWeight: 500, lineHeight: '20px', textTransform: 'none', color: (tripStatusFilter === null) ? 'white' : '#303646', backgroundColor: (tripStatusFilter === null) ? '#303646' : '#F3F4F7', border: '1px solid var(--white-100, #FFF)' }} />
                            <Chip 
                                onClick={() => {
                                    (tripStatusFilter === 'Confirmed') ? setTripStatusFilter(null) : setTripStatusFilter('Confirmed');
                                    setIsFilteringTrips(true);
                                }}
                                label={'Confirmed'} clickable style={{ height: '24px', padding: '10px 10px', borderRadius: '8px', fontFamily: 'Clashgrotesk, Arial, sans-serif', fontSize: '12px', fontWeight: 500, lineHeight: '20px', textTransform: 'none', color: (tripStatusFilter === 'Confirmed') ? 'white' : '#303646', backgroundColor: (tripStatusFilter === 'Confirmed') ? '#303646' : '#F3F4F7', border: '1px solid var(--white-100, #FFF)' }} />
                            <Chip 
                                onClick={() => {
                                (tripStatusFilter === 'Tentative') ? setTripStatusFilter(null) : setTripStatusFilter('Tentative');
                                setIsFilteringTrips(true);
                                }}
                                label={'Tentative'} clickable style={{ height: '24px', padding: '10px 10px', borderRadius: '8px', fontFamily: 'Clashgrotesk, Arial, sans-serif', fontSize: '12px', fontWeight: 500, lineHeight: '20px', textTransform: 'none', color: (tripStatusFilter === 'Tentative') ? 'white' : '#303646', backgroundColor: (tripStatusFilter === 'Tentative') ? '#303646' : '#F3F4F7', border: '1px solid var(--white-100, #FFF)' }} />
                            </Stack>
                        </div>
                    )}
                </div>) : null}

                {((selectedRec !== null) || (selectedTrip !== null)) ? (
                    <div className="list-area-close-btn-desktop-cont">
                        <Cancel 
                            className="list-area-close-btn-desktop"
                            onClick={() => mapView === 'recs' ? handleSelectedRecClick(null, selectedRec) :  handleSelectedTripClick(null, selectedTrip)}
                            fontSize="large" 
                        />
                    </div>
                ) : null}

                <div
                    className='list-area-desktop'
                    style={{ scrollbarWidth: 'none' }}
                >
                    <div
                        style={{
                            zIndex: 10001,
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            height: "100%",
                            scrollbarWidth: "none",
                            borderRadius: "24px 24px 0px 0px",
                        }}
                    >
                        {mapView === "recs" ? (
                        <>
                            

                            {/* Skeleton Loader */}
                            {updateCategory || loadingRecs ? (
                            <div className="List">
                                {[...Array(4)].map((_, index) => (
                                <div key={index} className="List-item">
                                    <Skeleton
                                    variant="rounded"
                                    width={mobile ? "90%" : "90%"}
                                    height={150}
                                    style={{ marginTop: 24, marginLeft: 20 }}
                                    />
                                </div>
                                ))}
                            </div>
                            ) : selectedRec !== null ? (
                            <List
                                height={650} // Viewport height for the virtualized list
                                itemCount={1}
                                itemSize={275} // Fixed height for each item
                                className="List"
                                width="100%"
                                >
                                {({ index, style }) => {
                                    const rec = selectedRec;
                                    return (
                                    <div
                                        style={style}
                                        className="List-item"
                                        onClick={() => handleSelectedRecClick(rec, selectedRec)}
                                    >
                                        {isFilteringRecs ? (
                                        <Skeleton
                                            variant="rounded"
                                            width={mobile ? "95%" : "90%"}
                                            height={165}
                                            sx={{ ml: 20 }}
                                        />
                                        ) : (
                                        <RecommendationsCard
                                            rec={rec}
                                            savedPlaceTypes={savedPlaceTypes}
                                            openModal={openModal}
                                        />
                                        )}
                                    </div>
                                    );
                                }}
                                </List>
                            ) : filteredRecs && filteredRecs.length ? (
                                <List
                                height={650} // Viewport height for the virtualized list
                                itemCount={filteredRecs.length}
                                itemSize={275} // Fixed height for each item
                                className="List"
                                width="100%"
                                >
                                {({ index, style }) => {
                                    const rec = filteredRecs[index];
                                    return (
                                    <div
                                        style={style}
                                        className="List-item"
                                        onClick={() => handleSelectedRecClick(rec, selectedRec)}
                                    >
                                        {isFilteringRecs ? (
                                        <Skeleton
                                            variant="rounded"
                                            width={mobile ? "95%" : "90%"}
                                            height={165}
                                        />
                                        ) : (
                                        <RecommendationsCard
                                            rec={rec}
                                            savedPlaceTypes={savedPlaceTypes}
                                            openModal={openModal}
                                        />
                                        )}
                                    </div>
                                    );
                                }}
                                </List>
                            ) : (
                            <div
                                style={{
                                width: "100%",
                                height: "60vh",
                                color: "gray",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                textAlign: "center",
                                }}
                            >
                                No Matching Places
                            </div>
                            )}
                        </>
                        ) : (mapView === 'trips') ? (
                        updateCategory || loadingTrips ? (
                            <div className="List">
                                {[...Array(4)].map((_, index) => (
                                    <div key={index} className="List-item">
                                    <Skeleton
                                        variant="rounded"
                                        width={mobile ? "90%" : "90%"}
                                        height={150}
                                        style={{ marginTop: 24 }}
                                    />
                                    </div>
                                ))}
                            </div>
                        ) : selectedTrip !== null ? (
                            <ul className="List">
                                <li key={selectedTrip.formattedDate} className="List-item" onClick={() => openModal()}>
                                <p className="Month-title">
                                    {selectedTrip.formattedDate.split('_')[0].replace(" ", " ‘")}
                                </p>
                                <ul className="Trip-list">
                                    <li className="Trip-list-item" key={selectedTrip._id}>
                                        <TripCard trip={selectedTrip} openModal={openModal} />
                                    </li>
                                </ul>
                                </li>
                            </ul>
                        ) : (
                            tripsData && tripsData.length ? (
                            <ul className="List">{filteredTripsListView.map((tripsD: any) => tripsD.data && tripsD.data.length ? <li key={tripsD.formattedDate} className="List-item">
                                <p className="Month-title">
                                {tripsD.formattedDate.split('_')[0].replace(" ", " ‘")}
                                </p>
                                <ul className="Trip-list">{tripsD?.data?.map((trip: any) => <li className="Trip-list-item" key={trip._id} onClick={() => handleSelectedTripClick(trip, selectedTrip)}>
                                {isFilteringTrips ? (
                                    <Stack spacing={2} style={{ marginTop: 20 }}>
                                        <Skeleton variant="rounded" width={mobile ? '95%' : '90%'} height={175} sx={{ ml: 20 }} />
                                    </Stack>
                                ) : (
                                    <Suspense fallback={
                                        <Stack spacing={2} style={{ marginTop: 20 }}>
                                            <Skeleton variant="rounded" width={mobile ? '95%' : '90%'} height={175} sx={{ ml: 20 }} />
                                        </Stack>
                                    }>
                                        <TripCard trip={trip} openModal={openModal} />
                                    </Suspense>
                                )}
                                </li>)}</ul>
                            </li> : null)}</ul>
                            ) : (
                            <div style={{ width: '100%', height: '60vh', paddingBottom: 50, color: 'gray', display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>No Trips Added Yet</div>
                            )
                        )
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
        <div style={{ width: '69%', height: '100%' }}>
            <NewMapComponent mapView={mapView} recs={filteredRecs} trips={filteredTripsMapView} selectedRec={selectedRec} selectedTrip={selectedTrip} setSelectedRec={setSelectedRec} setSelectedTrip={setSelectedTrip} loadingRecs={loadingRecs} isFilteringRecs={isFilteringRecs} loadingTrips={loadingTrips} locationTags={locationTags} isFilteringTrips={isFilteringTrips} />
        </div>
      </div>
  )
}

export default React.memo(DesktopParentMapComponent);